import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Influencer from "./Pages/Influencer/Influencer";
import Activist from "./Pages/Activist/Activist";
import WhiteHouse from "./Pages/WhiteHouse/WhiteHouse";
import Area51 from "./Pages/Area51/Area51";
import TimeSquare from "./Pages/TimeSquare/TimeSquare";
import Vatican from "./Pages/Vatican/Vatican";
import Everest from "./Pages/Everest/Everest";
import Buckingham from "./Pages/Buckingham/Buckingham";
import Dublin from "./Pages/Dublin/Dublin";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/influencer/phone" element={<Influencer />} />
          <Route path="/Activist/phone" element={<Activist />} />
          <Route path="/WhiteHouse/phone" element={<WhiteHouse />} />
          <Route path="/Area51/phone" element={<Area51 />} />
          <Route path="/TimeSquare/phone" element={<TimeSquare />} />
          <Route path="/Vatican/phone" element={<Vatican />} />
          <Route path="/Everest/phone" element={<Everest />} />
          <Route path="/Buckingham/phone" element={<Buckingham />} />
          <Route path="/Dublin/phone" element={<Dublin />} />
          <Route path="/" />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
